var React = require('react');

function Graph260px (props) {
    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M59 40H1a1 1 0 0 1-1-1V.999a1 1 0 0 1 2 0V38h57a1 1 0 1 1 0 2zm-9.5-28.001a3.456 3.456 0 0 1-1.751-.487l-10.084 9.517c.209.449.335.944.335 1.471 0 1.93-1.57 3.5-3.5 3.5S31 24.43 31 22.5c0-.57.15-1.101.393-1.577l-5.425-5.528-10.325 9.595c.222.459.357.967.357 1.51 0 1.929-1.57 3.5-3.5 3.5S9 28.429 9 26.5s1.57-3.5 3.5-3.5c.659 0 1.269.194 1.796.512l11.023-10.244a1.002 1.002 0 0 1 1.395.031l6.06 6.175a3.452 3.452 0 0 1 1.726-.475c.675 0 1.301.202 1.836.534l10.044-9.48A3.46 3.46 0 0 1 46 8.499a3.503 3.503 0 0 1 3.5-3.498c1.93 0 3.5 1.57 3.5 3.498 0 1.93-1.57 3.5-3.5 3.5zM12.5 25c-.827 0-1.5.673-1.5 1.5a1.501 1.501 0 0 0 3 0c0-.827-.673-1.5-1.5-1.5zm22-4.001c-.827 0-1.5.674-1.5 1.501 0 .827.673 1.5 1.5 1.5s1.5-.673 1.5-1.5-.673-1.501-1.5-1.501zM49.5 7c-.827 0-1.5.673-1.5 1.499a1.501 1.501 0 0 0 3 0C51 7.673 50.327 7 49.5 7z","key":1})]);
}

Graph260px.displayName = "Graph260px";

Graph260px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 60 40"};

module.exports = Graph260px;

Graph260px.default = Graph260px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/60px/graph-2-60px.svg
// module id = 1193
// module chunks = 0